module.exports = __webpack_public_path__ + "static/img/zhi.0afadead.png";